import apiClient from './api';

export interface AccountInfo {
  accountId: string;
  companyName?: string;
  supportedLanguages?: string[];
  settings: {
    supportedLanguages: string[];
    defaultLanguage?: string;
    timezone?: string;
  };
}

export const accountService = {
  /**
   * Get account information (public read-only)
   * Public backend returns account info based on subdomain
   */
  getAccountInfo: async (): Promise<AccountInfo> => {
    const response = await apiClient.get<AccountInfo>('/api/account');
    // Ensure settings structure exists
    const data = response.data;
    if (!data.settings) {
      return {
        ...data,
        settings: {
          supportedLanguages: data.supportedLanguages || ['en'],
        },
      };
    }
    return data;
  },
};

